import LayoutContainer from "../../components/Containers/LayoutContainer";
import ZoomWebinarData from "./Zoom_Webinar_Data";

const Zoom_Webinar = () => {
  return (
    <LayoutContainer title="Zoom and Webinar Links">
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          Zoom and Webinar Links
        </h2>
      </div>
      <ZoomWebinarData />
    </LayoutContainer>
  );
};

export default Zoom_Webinar;
